'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { ChevronUp } from 'lucide-react';

function TwitterIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
    </svg>
  );
}

function InstagramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function YoutubeIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
      <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
    </svg>
  );
}

function FacebookIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-4h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

export function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const sections = {
    songs: {
      title: 'SONGS',
      links: [
        { name: 'Popular Songs', href: '/browse?category=songs' },
        { name: '2026 Songs', href: '/browse?category=songs&year=2026' },
        { name: '2025 Songs', href: '/browse?category=songs&year=2025' },
        { name: 'Hindi Songs', href: '/browse?category=songs&language=hindi' },
        { name: 'Tamil Songs', href: '/browse?category=songs&language=tamil' },
        { name: 'Telugu Songs', href: '/browse?category=songs&language=telugu' },
        { name: 'Malayalam Songs', href: '/browse?category=songs&language=malayalam' },
      ],
    },
    moviesAndAlbums: {
      title: 'MOVIES & ALBUMS',
      links: [
        { name: '2026 Movies', href: '/browse?category=movies&year=2026' },
        { name: '2025 Movies', href: '/browse?category=movies&year=2025' },
        { name: '2024 Movies', href: '/browse?category=movies&year=2024' },
        { name: 'Hindi Movies', href: '/browse?category=movies&language=hindi' },
        { name: 'Tamil Movies', href: '/browse?category=movies&language=tamil' },
        { name: 'Telugu Movies', href: '/browse?category=movies&language=telugu' },
        { name: 'Malayalam Movies', href: '/browse?category=movies&language=malayalam' },
      ],
    },
    discover: {
      title: 'TOP STARS',
      links: [
        { name: 'Thalapathy Vijay Songs', href: '/person/vijay' },
        { name: 'Superstar Rajinikanth Songs', href: '/person/rajinikanth' },
        { name: 'Vijay Sethupathi Songs', href: '/person/vijay-sethupathi' },
        { name: 'Ranbir Kapoor Songs', href: '/person/ranbir-kapoor' },
        { name: 'Pradeep Ranganathan Songs', href: '/person/pradeep-ranganathan' },
      ],
    },
    topArtists: {
      title: 'TOP ARTISTS',
      links: [
        { name: 'Anirudh Songs', href: '/person/anirudh-ravichander' },
        { name: 'S. Thaman Songs', href: '/person/thaman-s' },
        { name: 'Pritam Songs', href: '/person/pritam' },
        { name: 'A. R. Rahman Songs', href: '/person/a-r-rahman' },
        { name: 'Devi Sri Prasad Songs', href: '/person/devi-sri-prasad' },
        { name: 'Sushin Shyam Songs', href: '/person/sushin-shyam' },
        { name: 'Yuvan Shankar Raja Songs', href: '/person/yuvan-shankar-raja' },
      ],
    },
    company: {
      title: 'COMPANY',
      links: [
        { name: 'About Us', href: '/about-us' },
        { name: 'Contact Us', href: '/contact' },
        { name: 'FAQ', href: '/contact#faq' },
      ],
    },
    legal: {
      title: 'LEGAL',
      links: [
        { name: 'Privacy Policy', href: '/privacy-policy' },
        { name: 'Terms of Service', href: '/terms-of-service' },
        { name: 'Disclaimer', href: '/disclaimer' },
        { name: 'Cookie Policy', href: '/cookie-policy' },
        { name: 'DMCA Policy', href: '/dmca' },
        { name: 'Refund Policy', href: '/terms-of-service#refund-policy' },
        { name: 'Security Policy', href: '/privacy-policy#security-policy' },
      ],
    },
  };

  const renderLinkList = (section) => (
    <div>
      <h3 className="text-white font-bold text-xs sm:text-sm tracking-wider uppercase mb-3.5">
        {section.title}
      </h3>
      <ul className="space-y-2">
        {section.links.map((link) => (
          <li key={link.name}>
            {link.isExternal ? (
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs sm:text-sm text-zinc-400 hover:text-teal-400 transition-colors block leading-snug"
              >
                {link.name}
              </a>
            ) : (
              <Link
                href={link.href}
                prefetch={false}
                className="text-xs sm:text-sm text-zinc-400 hover:text-teal-400 transition-colors block leading-snug"
              >
                {link.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer className="bg-[#0B0F17] text-zinc-300 border-t border-zinc-800/80 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          
          {/* Brand Info Column */}
          <div className="lg:col-span-3 space-y-5 flex flex-col items-center lg:items-start text-center lg:text-left">
            <div className="flex items-center gap-2.5">
              <Image 
                src="/images/lyricsverse.png" 
                alt="LyricsVerse Logo" 
                width={32} 
                height={32} 
                className="w-8 h-8 object-contain" 
              />
              <span className="text-xl sm:text-2xl font-bold tracking-tight text-white">
                LyricsVerse
              </span>
            </div>

            <p className="text-teal-400 font-medium text-xs sm:text-sm">
              Discover your next favorite lyrics.
            </p>

            <p className="text-zinc-400 text-xs sm:text-sm leading-relaxed max-w-xs">
              Explore songs, movie lyrics, reviews, recommendations, streaming guides, and AI-powered discovery from around the world.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-2.5 pt-1">
              <a
                href="https://x.com/LyricsVerseTeam"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-zinc-800 bg-zinc-900/60 flex items-center justify-center text-zinc-300 hover:text-white hover:border-teal-400 hover:bg-zinc-800 transition-all"
                aria-label="Twitter"
              >
                <TwitterIcon className="w-3.5 h-3.5" />
              </a>
              <a
                href="https://www.instagram.com/lyricsverseteam/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-zinc-800 bg-zinc-900/60 flex items-center justify-center text-zinc-300 hover:text-white hover:border-teal-400 hover:bg-zinc-800 transition-all"
                aria-label="Instagram"
              >
                <InstagramIcon className="w-3.5 h-3.5" />
              </a>
              <a
                href="https://www.youtube.com/@LyricsVerseTeam"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-zinc-800 bg-zinc-900/60 flex items-center justify-center text-zinc-300 hover:text-white hover:border-teal-400 hover:bg-zinc-800 transition-all"
                aria-label="YouTube"
              >
                <YoutubeIcon className="w-3.5 h-3.5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61592158151271"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-zinc-800 bg-zinc-900/60 flex items-center justify-center text-zinc-300 hover:text-white hover:border-teal-400 hover:bg-zinc-800 transition-all"
                aria-label="Facebook"
              >
                <FacebookIcon className="w-3.5 h-3.5" />
              </a>
            </div>

            {/* Back to Top Button */}
            <div className="pt-1">
              <button
                type="button"
                onClick={scrollToTop}
                aria-label="Back to top"
                className="px-4 py-2 rounded-lg border border-zinc-800 bg-zinc-900/60 hover:bg-zinc-800 hover:border-teal-400/50 text-[11px] font-bold tracking-wider text-zinc-200 uppercase flex items-center gap-1.5 transition-all cursor-pointer shadow-sm"
              >
                <ChevronUp className="w-3.5 h-3.5" />
                BACK TO TOP
              </button>
            </div>
          </div>

          {/* Links Grid Section */}
          <div className="lg:col-span-9 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8">
            <div>{renderLinkList(sections.songs)}</div>
            <div>{renderLinkList(sections.moviesAndAlbums)}</div>
            <div>{renderLinkList(sections.discover)}</div>
            <div>{renderLinkList(sections.topArtists)}</div>
            <div>{renderLinkList(sections.company)}</div>
            <div>{renderLinkList(sections.legal)}</div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800/80 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-zinc-400">
          <p>© {currentYear} LyricsVerse. All Rights Reserved.</p>
          <p className="text-center sm:text-right">
            Data provided by music partners. LyricsVerse is not endorsed or certified by streaming platforms.
          </p>
        </div>

      </div>
    </footer>
  );
}
